import { Reveal } from "@/components/Reveal";

export function SectionHeading({ kicker, title, text, light = false, align = "left", className = "" }) {
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <Reveal className={`flex flex-col ${alignCls} max-w-2xl ${align === "center" ? "mx-auto" : ""} ${className}`}>
      {kicker && (
        <span className="flex items-center gap-2 mb-4 font-body text-xs font-semibold tracking-[0.25em] uppercase" style={{ color: "#F2B233" }}>
          <span className="w-8 h-px bg-amber" /> {kicker}
        </span>
      )}
      <h2 className={`font-display font-bold uppercase leading-[0.95] tracking-tight text-[clamp(30px,4vw,56px)] ${light ? "text-white" : "text-ink"}`}>
        {title}
      </h2>
      {text && (
        <p className={`mt-5 text-[clamp(16px,2vw,18px)] leading-relaxed ${light ? "text-white/70" : "text-muted"}`}>
          {text}
        </p>
      )}
    </Reveal>
  );
}
